import React from 'react';

interface SettingsTabProps {
  tenantName: string;
  setTenantName: (v: string) => void;
  currentTenantName: string | undefined;
  settingsLoading: boolean;
  onUpdateTenantName: (e: React.FormEvent) => void;
  onRequestDeleteTeam: () => void;
}

export const SettingsTab: React.FC<SettingsTabProps> = ({
  tenantName,
  setTenantName,
  currentTenantName,
  settingsLoading,
  onUpdateTenantName,
  onRequestDeleteTeam,
}) => {
  return (
    <div className="space-y-4">
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Team Name</h3>
        <form onSubmit={onUpdateTenantName} className="flex gap-3">
          <input
            type="text"
            value={tenantName}
            onChange={(e) => setTenantName(e.target.value)}
            className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            required
          />
          <button
            type="submit"
            disabled={settingsLoading || tenantName === currentTenantName}
            className="px-4 py-2 bg-teal-600 dark:bg-teal-500 text-white rounded-lg hover:bg-teal-700 dark:hover:bg-teal-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {settingsLoading ? 'Saving...' : 'Save'}
          </button>
        </form>
      </div>

      <div className="bg-white dark:bg-gray-800 border border-red-200 dark:border-red-800 rounded-lg p-4">
        <h3 className="text-base font-semibold text-red-600 dark:text-red-400 mb-3">Danger Zone</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
          Deleting your team will remove all members, invitations, and associated data. This action
          cannot be undone.
        </p>
        <button
          onClick={onRequestDeleteTeam}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          Delete Team
        </button>
      </div>
    </div>
  );
};
